import React, { Component } from "react";
import DynamicRow from "./DynamicRow";
import { DropZone } from "./DropZones";
import { getBoundingClientRect } from "../../utils/functions";

class Section extends Component {
    state = {
        partials: {
            partialWidth: 90,
            partialMargin: 5
        },
        isOnLeftZone: false,
        isOnMiddleZone: false,
        isOnRightZone: false,
        isOnRowLeftZone: false,
        isOnRowMiddleZone: false,
        isOnRowRightZone: false,
        isOnSectionZone: false
    };

    render() {
        const sectionRect = getBoundingClientRect(this.sectionRef);
        const sectionWidth = sectionRect.width;
        const {
            isOnLeftZone,
            isOnMiddleZone,
            isOnRightZone,
            isOnRowLeftZone,
            isOnRowMiddleZone,
            isOnRowRightZone,
            isOnSectionZone,
            partials
        } = this.state;

        return (
            <div
                ref={(el) => (this.sectionRef = el)}
                style={{
                    // background: "red",
                    width: "100%",
                    minHeight: 400,
                    // paddingTop: 5,
                    position: "relative",
                    border: this.props.showStructures ? "1px dashed black" : ""
                }}
            >
                {this.props.rowsInSection.map((row, rowIndex) => {
                    const { rowId, columnsInRow } = row;
                    return (
                        <DynamicRow
                            sectionId={this.props.sectionId}
                            partials={partials}
                            key={rowId}
                            columnsInRow={columnsInRow}
                            sectionRect={sectionRect}
                            addGhostElementOnDragOver={
                                this.props.addGhostElementOnDragOver
                            }
                            removeGhostElementOnDragLeave={
                                this.props.removeGhostElementOnDragLeave
                            }
                            setDragZoneStatus={(stateName, value) =>
                                // this.setState({ [stateName]: value })
                                console.log(
                                    "SETTTTTTTTTTTTTTTTTTTTTTTT",
                                    stateName,
                                    value
                                )
                            }
                        />
                    );
                })}
                {this.props.showStructures ? (
                    <div
                        style={{
                            width: "100%",
                            minHeight: 75,
                            // background: 'yellow',
                            height: "100%",
                            display: "flex",
                            position: "absolute",
                            top: 0
                        }}
                    >
                        <DropZone
                            elDragData={this.props.elDragData}
                            addGhostElementOnDragOver={() =>
                                this.props.addGhostElementOnDragOver(
                                    "ON_LEFT_SIDE",
                                    {}
                                )
                            }
                            removeGhostElementOnDragLeave={() =>
                                this.props.removeGhostElementOnDragLeave(
                                    "ON_LEFT_SIDE"
                                )
                            }
                            sectionRect={sectionRect}
                            setDragZoneStatus={(status) =>
                                this.setState({ isOnLeftZone: status })
                            }
                            style={{
                                borderRight: "1px dashed black",
                                userSelect: "none",
                                zIndex: 1,
                                width: `${partials.partialMargin}%`
                                // width: 20
                            }}
                        />
                        <DropZone
                            sectionId={this.props.sectionId}
                            elDragData={this.props.elDragData}
                            addGhostElementOnDragOver={() =>
                                this.props.addGhostElementOnDragOver(
                                    "ON_MIDDLE_SIDE",
                                    {}
                                )
                            }
                            removeGhostElementOnDragLeave={() =>
                                this.props.removeGhostElementOnDragLeave(
                                    "ON_MIDDLE_SIDE"
                                )
                            }
                            sectionRect={sectionRect}
                            setDragZoneStatus={(status) =>
                                this.setState({ isOnMiddleZone: status })
                            }
                            style={{
                                borderRight: "1px dashed black",
                                userSelect: "none",
                                zIndex: 1,
                                width: `calc(100% - ${
                                    partials.partialMargin * 2
                                }%)`
                                // width: 80
                            }}
                        />
                        <DropZone
                            sectionId={this.props.sectionId}
                            elDragData={this.props.elDragData}
                            addGhostElementOnDragOver={() =>
                                this.props.addGhostElementOnDragOver(
                                    "ON_RIGHT_SIDE",
                                    {}
                                )
                            }
                            removeGhostElementOnDragLeave={() =>
                                this.props.removeGhostElementOnDragLeave(
                                    "ON_RIGHT_SIDE"
                                )
                            }
                            sectionRect={sectionRect}
                            setDragZoneStatus={(status) =>
                                this.setState({ isOnRightZone: status })
                            }
                            style={{
                                width: `${partials.partialMargin}%`,
                                // width: 20,
                                userSelect: "none",

                                zIndex: 1
                                // borderRight: "1px dashed black"
                            }}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

export default Section;
